import { IAppVersion } from "models/appVersion";
import DeleteIcon from "components/Icons/DeleteIcon";
import { useAppVersionAlertContext } from "./AlertContext";

interface IProps {
  appVersion: IAppVersion;
}

export default function Action({ appVersion }: IProps) {
  const { showDelete } = useAppVersionAlertContext();

  const handleClick = () => {
    showDelete(appVersion);
  };

  return (
    <div className="flex items-center justify-center">
      <button onClick={handleClick} className="rounded-ful text-red-600">
        <DeleteIcon />
      </button>
    </div>
  );
}
